import React, { FC, createContext } from 'react';
import { usePricing } from './usePricing';
import { Pricing } from '../../types/common';

export const PricingContext = createContext({} as PricingContextType);

interface PricingContextType {
  pricing: any;
}

interface WithPricingProps {
  [key: string]: any;
}

export const withPricing = <P extends WithPricingProps>(
  Page: FC<P>,
  bakedPricing: Pricing
) => {
  const PricingProviderHOC: FC<P> = (props) => {
    const pricing = usePricing(bakedPricing);

    return (
      <PricingContext.Provider value={{ pricing } as PricingContextType}>
        <Page {...props} />
      </PricingContext.Provider>
    );
  };

  return PricingProviderHOC;
};

export default withPricing;
